import Viewport from './Viewport';

export default Viewport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-viewport/es/index.js
// module id = 540
// module chunks = 0